<template>
  <q-btn dense flat icon="file_copy" @click="copyText">
    <ToolTip :class="`text-body2 ${tooltipClasses}`" :model-value="copied" no-parent-event :offset="[0, 8]"
      >Copied!</ToolTip
    >
  </q-btn>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import ToolTip from 'components/ToolTip.vue';
import { copy } from 'src/services/clipboard';
import { setTimeoutPromise } from 'src/services/setTimeout';

const props = withDefaults(defineProps<{ text: string; tooltipClasses?: string }>(), {
  tooltipClasses: '',
});

const copied = ref(false);
async function copyText() {
  copy(props.text);
  copied.value = true;
  await setTimeoutPromise(1000);
  copied.value = false;
}
</script>
